import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { identifyComponent } from '../../../util';
import css from './index.module.scss';
import { TableBodyCellBase as TableBodyCellBaseType } from './types';

export const TableBodyCellBase: TableBodyCellBaseType = ({
  children,
  className,
  align,
  borders = 'horizontal',
  ...rest
}) => {
  const classes = classNames(className, css.tableBodyCell, {
    [css.bordersVertical]: borders === 'vertical' || borders === 'all',
    [css.bordersHorizontal]: borders === 'horizontal' || borders === 'all' || borders === 'bottom',
  });
  return (
    <td
      data-component="TableBodyCellBase"
      className={classes}
      align={align}
      {...rest}
      {...identifyComponent('table-body-cell-base', rest)}
    >
      {children}
    </td>
  );
};
